const M = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDUxMiAzNDEuMyI+CjxyZWN0IHk9IjAiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSI1MTIiIGhlaWdodD0iMzQxLjMiLz4KPHBvbHlnb24gZmlsbD0iIzJFNTJCMiIgcG9pbnRzPSI1MTIsMTI5LjMgNTEyLDIxMiAyMDMuNywyMTIgMjAzLjcsMzQxLjMgMTIxLDM0MS4zIDEyMSwyMTIgMCwyMTIgMCwxMjkuMyAxMjEsMTI5LjMgMTIxLDAgMjAzLjcsMAoJMjAzLjcsMTI5LjMgIi8+Cjwvc3ZnPgo=";
export {
  M as default
};
//# sourceMappingURL=FI-2d733f0b.mjs.map
